import Avatar from "react-avatar";
import axios from "axios";
import useCookie from "../hooks/useCookie";
import useCurrentUser from "../hooks/useCurrentUser";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";
import { EntityManagementContext } from "../context/EntityManagementContext";

function AdminRow(props) {
    let user = null;
    user = useCurrentUser();

    const {
        setMode,
        setEditingID,
        openPopup,
        admins,
        setAdmins
    } = useContext(EntityManagementContext);

    const { blue, white } = useContext(ColorContext);

    const csrftoken = useCookie("csrftoken");

    const headers = {
        "X-CSRFToken": csrftoken,
    };

    // When the user elects to edit this admin record
    // (via button press), change mode to "Edit", specify
    // this as the target ID, and open popup if
    // layout necessitates it
    const editAdmin = () => {
        setMode("Edit");
        setEditingID(props.id);
        openPopup(); // If page is narrow, open popup
    }

    // When the user elects to delete this admin
    // record via button press, remove this record
    // from the admins state
    const deleteAdmin = (event) => {
        event.preventDefault();

        let deletionConfirmation = false;

        // Confirm admin deletion:

        // If user is deleting themself...
        if (user && user.id == props.id) {
            deletionConfirmation = window.confirm(
                `\nYou are about to delete your own account from the system. Are you sure?
                \nPress OK to confirm, or cancel this action.`
            );
        } 
        // If user is deleting another admin...
        else {
            deletionConfirmation = window.confirm(
                `\nDelete ${props.name}?\nPress OK to confirm, or cancel this action.`
            );
        }

        // Delete admin if user gave confirmation
        if (deletionConfirmation) {
            axios
                .delete(`/api/admins/${props.id}/`, { headers })
                .then(() => {
                    let mutableAdmins = admins;
                    mutableAdmins = mutableAdmins.filter(admin => admin.id != props.id);
                    setAdmins(mutableAdmins);
                })
                .catch((error) => console.error(error));
        }
    }
    
    return(
        <>
            <td>
                <Avatar name={props.name} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                {props.name} {/* Name */}
            </td>
            <td>
                {props.email} {/* Email */}
            </td>
            {/* Actions */}
            <td>
                {/* Rules:
                    - Only the master admin can edit/delete other admin
                    - The master admin cannot be edited or deleted
                    - Admin may edit or delete themselves; choice to delete will be confirmed via popup */}
                {
                    // General admin looking at themself, or...
                    (((user && user.id != 1 && user.id == props.id)
                    // Master admin looking at general admin...
                    || (user && user.id == 1 && user.id != props.id)) ? 
                    (<>
                        <button onClick={editAdmin}>Edit</button> {/* Edit button */}
                        <button onClick={deleteAdmin}>Delete</button> {/* Delete button */}
                    </>) : <></> )
                }
            </td>
        </>
    );
}

export default AdminRow;